import { useEffect, useRef, useState } from "react";
import { Box, Button, Flex, Tabs, useBreakpointValue, useDisclosure } from "@chakra-ui/react";
import { t } from "i18next";
import { LocationsTabList, LocationsTabPanels } from "./LocationsTabs";
import { ConfirmationDialog } from "../../../components/ConfirmationDialog";
import * as React from "react";

function LocationQuestionnaire({ data, returnToListRequested, returnToList }) {
  const [locationTabIndex, setLocationTabIndex] = useState(0);
  const [action, setAction] = useState("");
  const [finalize, setFinalize] = useState(false);
  const { isOpen: isConfirmDialogOpen, onOpen: onConfirmDialogOpen, onClose: onConfirmDialogClose } = useDisclosure();

  const locationsTabsState = useBreakpointValue({ base: true, xl: false });
  const [locationTabsCollapsed, setLocationTabsCollapsed] = useState(false);
  const saveBtnRef = useRef();

  useEffect(() => {
    setLocationTabsCollapsed(locationsTabsState);
  }, [locationsTabsState]);

  useEffect(() => {
    if (returnToListRequested === true) {
      saveBtnRef.current.click();
    }
  }, [returnToListRequested]);

  const handleTabsCollapse = (areCollapsed) => {
    setLocationTabsCollapsed(areCollapsed);
  };

  const handleFinalizeConfirmation = () => {
    const currentForm = document.getElementById(`formStep${data.physicalRiskLocations[locationTabIndex].id}`);
    if (currentForm) {
      currentForm.dispatchEvent(new Event("submit", { cancelable: true, bubbles: true }));
      handleDialogClose(true);
    }
  };

  const handleDialogClose = (confirmed) => {
    if (confirmed !== true) {
      setFinalize(false);
    }
    onConfirmDialogClose();
  };

  return (
    <Box>
      <Tabs
        variant="unstyled"
        orientation="vertical"
        overflow="hidden"
        position="relative"
        isLazy
        isManual
        index={locationTabIndex}
        onChange={setLocationTabIndex}
        maxBlockSize={{ base: "none", lg: "lg" }}
        marginInlineEnd="-4"
      >
        <LocationsTabList
          currentIndex={locationTabIndex}
          locations={data.physicalRiskLocations}
          tabsCollapsed={locationTabsCollapsed}
          setTabsCollapsed={handleTabsCollapse}
        />
        <LocationsTabPanels
          defaultValues={data}
          onTabChange={setLocationTabIndex}
          action={action}
          setAction={setAction}
          locations={data.physicalRiskLocations}
          finalize={finalize}
          tabsCollapsed={locationTabsCollapsed}
          returnToListRequested={returnToListRequested}
          returnToList={returnToList}
        />
      </Tabs>
      <Flex
        marginBlockStart="10"
        justifyContent={"end"}
        position="sticky"
        bottom="0"
        backgroundColor="#fff"
        borderColor="esg_gray.100"
        bordersyle="solid"
        borderTopWidth="1px"
        zIndex="10"
        paddingBlock="4"
      >
        <Flex gap="2">
          <Button
            form={`formStep${data.physicalRiskLocations[locationTabIndex].id}`}
            colorScheme="white"
            color={"esg_lightgreen"}
            border={"1px solid"}
            borderColor={"esg_lightgreen"}
            type="submit"
            width="32"
            ref={saveBtnRef}
          >
            {t("buttons.save")}
          </Button>
          <Button
            form={`formStep${data.physicalRiskLocations[locationTabIndex].id}`}
            colorScheme="customScheme"
            width="32"
            onClick={() => {
              setFinalize(true);
              onConfirmDialogOpen();
            }}
          >
            {t("buttons.finalize")}
          </Button>
        </Flex>
      </Flex>
      <ConfirmationDialog
        isOpen={isConfirmDialogOpen}
        onClose={handleDialogClose}
        onConfirm={handleFinalizeConfirmation}
        headerText={t("questionnaireFinalizationDialog.header")}
        confirmationText={t("questionnaireFinalizationDialog.question")}
      />
    </Box>
  );
}

export default LocationQuestionnaire;